import http from "../http-common";

const headers = {
  "x-api-key": "DA40iS39XR4zl4vORgYsM9YfEXdLh1Rv3beShxvh",
};

class DashboardDataService {
  getDashboardData(
    access_code: string,
    department: string,
    location: string,
    fromdate: string,
    todate: string
  ) {
    return http.get(
      `dashboard?code=${access_code}&fromdate=${fromdate}&todate=${todate}&department=${
        access_code === "ManoSXUno" ? department : ""
      }&location=${access_code === "ManoSXUno" ? location : ""}`,
      { headers }
    );
  }
  getSelfCareData(
    access_code: string,
    department: string,
    location: string,
    fromdate: string,
    todate: string
  ) {
    return http.get(
      `dashboard/self-help?code=${access_code}&fromdate=${fromdate}&todate=${todate}&department=${
        access_code === "ManoSXUno" ? department : ""
      }&location=${access_code === "ManoSXUno" ? location : ""}`,
      { headers }
    );
  }
  getAssessmentsData(
    access_code: string,
    department: string,
    location: string,
    fromdate: string,
    todate: string
  ) {
    return http.get(
      `dashboard/assessments?code=${access_code}&fromdate=${fromdate}&todate=${todate}&department=${
        access_code === "ManoSXUno" ? department : ""
      }&location=${access_code === "ManoSXUno" ? location : ""}`,
      { headers }
    );
  }

  getBookingsData(
    access_code: string,
    department: string,
    location: string,
    fromdate: string,
    todate: string
  ) {
    return http.get(
      `dashboard/bookings?code=${access_code}&fromdate=${fromdate}&todate=${todate}&department=${
        access_code === "ManoSXUno" ? department : ""
      }&location=${access_code === "ManoSXUno" ? location : ""}`,
      { headers }
    );
  }
  getWorkshopsData(
    access_code: string,
    department: string,
    location: string,
    fromdate: string,
    todate: string
  ) {
    return http.get(
      `dashboard/workshops?code=${access_code}&fromdate=${fromdate}&todate=${todate}&department=${
        access_code === "ManoSXUno" ? department : ""
      }&location=${access_code === "ManoSXUno" ? location : ""}`,
      { headers }
    );
  }
  login(data: any) {
    return http.post(`dashboard/login`, data, { headers });
  }
  getYogaData(access_code: string) {
    return http.get(`dashboard/yoga-attendance?code=${access_code}`, {
      headers,
    });
  }
  getEmployeesDetails(access_code: string) {
    return http.get(`dashboard/employees?code=${access_code}`, {
      headers,
    });
  }
}
export default new DashboardDataService();
